import React from 'react';

import SpriteIcon from 'web/components/common/icon/SpriteIcon';

import classNames from 'classnames/bind';
import styles from './Checkbox.scss';
const cx = classNames.bind(styles);

const Checkbox = React.memo(
  ({
    tabIndex = '0',
    type = 'checkbox',
    name,
    id,
    value,
    msg,
    style = {},
    checkStyle = {},
    onChange,
  }) => {
    return (
      <div className={cx('Checkbox')} style={style}>
        <label htmlFor={id}>
          <span className={`check ${value}`} style={checkStyle}>
            {value ? (
              <SpriteIcon
                name={`img-cb-check`}
                style={{ position: 'absolute', left: '2px', top: '4px' }}
              />
            ) : null}
          </span>
          <span className="msg" dangerouslySetInnerHTML={{ __html: msg }} />
          <input
            tabIndex={tabIndex}
            type={type}
            name={name}
            id={id}
            value={value}
            onChange={onChange}
          />
        </label>
      </div>
    );
  },
);

export default Checkbox;
